import { useState, type FormEvent } from 'react';
import { ApiError, isOffline } from '../api/client';
import { login } from '../session';

/**
 * There is no registration screen and no password reset, because there is no
 * registration endpoint: both accounts are created by hand on the server
 * (ARCHITECTURE §12). Pretending otherwise would be a screen that cannot work.
 */
export function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      // The session gate re-reads /me on mount, so a reload is the simplest
      // correct way to enter the app with everything initialised.
      window.location.replace('/');
    } catch (err) {
      if (isOffline(err)) setError('Geen verbinding — inloggen kan niet zonder.');
      else if (err instanceof ApiError && err.status === 401)
        setError('Dit e-mailadres en wachtwoord horen niet bij elkaar.');
      else if (err instanceof ApiError && err.status === 429)
        // Named rather than folded into "something went wrong", because this
        // one has a specific and reassuring answer: wait, then try again. The
        // generic message would read as the app being broken.
        setError('Te veel pogingen. Wacht een paar minuten en probeer het opnieuw.');
      else setError('Er ging iets mis. Probeer het opnieuw.');
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1>Family Hub</h1>
      <form className="stack" onSubmit={submit}>
        <label className="sheet-field">
          <span className="sheet-label">E-mailadres</span>
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="sheet-field">
          <span className="sheet-label">Wachtwoord</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <p style={{ color: 'var(--danger)' }}>{error}</p>}
        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? 'Inloggen…' : 'Inloggen'}
        </button>
      </form>
    </main>
  );
}
